/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sprachanforderungen_DeInputs */

const de_sprachanforderungen_de = /** @type {(inputs: Sprachanforderungen_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsche Sprachanforderungen`)
};

/** @type {(inputs: Sprachanforderungen_DeInputs) => LocalizedString} */
const en_sprachanforderungen_de = () => /** @type {LocalizedString} */ ('sprachanforderungen_de')

/**

* @param {Sprachanforderungen_DeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sprachanforderungen_de = /** @type {((inputs?: Sprachanforderungen_DeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sprachanforderungen_DeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sprachanforderungen_de(inputs)
	return en_sprachanforderungen_de(inputs)
});